import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Icon, Modal } from 'scala'
import { useCallback, useState } from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'
import { TaskPostVideoOrientation } from '../../../types/task.types'

interface Props {
  title?: string
  video?: string
  thumbnail?: string
  duration?: number
  orientation?: TaskPostVideoOrientation
}

export const PlaylistVideo: React.FC<Props> = ({
  title,
  video,
  thumbnail,
  duration,
  orientation = TaskPostVideoOrientation.LANDSCAPE
}) => {
  const { i18n } = useLingui()
  const [open, setOpen] = useState(false)

  const onOpenModal = useCallback(() => setOpen(true), [])
  const onCloseModal = useCallback(() => setOpen(false), [])

  return (
    <>
      <button
        type="button"
        onClick={onOpenModal}
        className={classNames(styles.button, {
          [styles.portrait]: orientation === TaskPostVideoOrientation.PORTRAIT
        })}
      >
        <span>
          <img
            alt={title}
            src={thumbnail}
            className={classNames(styles.image, {
              [styles.portraitImage]:
                orientation === TaskPostVideoOrientation.PORTRAIT,
              [styles.landscapeImage]:
                orientation === TaskPostVideoOrientation.LANDSCAPE
            })}
          />
        </span>

        <span className={styles.col}>
          <p className={styles.title}>{title}</p>

          <span className={styles.bottom}>
            <Icon
              name="play-fill"
              className={classNames(styles.icon, {
                [styles.portraitIcon]:
                  orientation === TaskPostVideoOrientation.PORTRAIT,
                [styles.landscapeIcon]:
                  orientation === TaskPostVideoOrientation.LANDSCAPE
              })}
            />
            {duration && (
              <p className={styles.duration}>
                {duration < 60
                  ? `${duration} ${i18n._(t`label_second`)}`
                  : `${Math.floor(duration / 60)} ${i18n._(t`label_minute`)}`}
              </p>
            )}
          </span>
        </span>
      </button>

      <Modal
        isOpen={open}
        showCloseButton
        onClose={onCloseModal}
        targetId="moises-app"
        shouldCloseOnOverlayClick
        label="modal-video-playlist"
        modalClassName={styles.modal}
      >
        <div className={styles.contentModal}>
          <p className={styles.titleModal}>{title}</p>
          <video controls autoPlay src={video} className={styles.videoModal} />
        </div>
      </Modal>
    </>
  )
}
